<aside
  class="sidebar"
  [class.sidebar--open]="isOpen()"
  role="dialog"
  aria-label="Navigation menu"
  aria-hidden="{{ !isOpen() }}">
  <nav class="sidebar__nav" aria-label="Sidebar navigation">
    <ul class="sidebar__nav-list">
      @for (item of _allNavItems(); track item.path + item.label) {
        <li>
          @if (_isExternalLink(item.path)) {
            <a
              [href]="item.path"
              class="sidebar__nav-link"
              (click)="_onNavigate()">
              <span class="sidebar__nav-icon" aria-hidden="true">
                @if (item.icon) {
                  <app-layout-icon [icon]="item.icon" size="sm" />
                }
              </span>
              <span>{{ item.label | transloco }}</span>
            </a>
          } @else {
            <a
              [routerLink]="_resolvePath(item.path)"
              routerLinkActive="sidebar__nav-link--active"
              [routerLinkActiveOptions]="{
                exact: item.path === '' || item.path === '/home',
              }"
              class="sidebar__nav-link"
              (click)="_onNavigate()">
              <span class="sidebar__nav-icon" aria-hidden="true">
                @if (item.icon) {
                  <app-layout-icon [icon]="item.icon" size="sm" />
                }
              </span>
              <span>{{ item.label | transloco }}</span>
            </a>
          }
        </li>
      }
    </ul>
  </nav>

  <div class="sidebar__footer">
    <div class="sidebar__links">
      <a
        [href]="_legalUrl('privacy-policy')"
        target="_blank"
        rel="noopener noreferrer"
        class="sidebar__link"
        >{{ 'footer.privacyPolicy' | transloco }}</a
      >
      <a
        [href]="_legalUrl('terms-and-conditions')"
        target="_blank"
        rel="noopener noreferrer"
        class="sidebar__link"
        >{{ 'footer.termsAndConditions' | transloco }}</a
      >
      <a
        [href]="_legalUrl('compliance')"
        target="_blank"
        rel="noopener noreferrer"
        class="sidebar__link"
        >{{ 'footer.compliance' | transloco }}</a
      >
      <a
        [href]="_legalUrl('contact')"
        target="_blank"
        rel="noopener noreferrer"
        class="sidebar__link"
        >{{ 'footer.contactUs' | transloco }}</a
      >
    </div>
    <div class="sidebar__lang">
      <select
        [ngModel]="_currentLocale()"
        (ngModelChange)="_onLocaleChange($event)"
        class="sidebar__select"
        [attr.aria-label]="'locale.selectLanguage' | transloco">
        @for (lang of _availableLocales(); track lang) {
          <option [value]="lang">{{ _getLanguageName(lang) }}</option>
        }
      </select>
    </div>
    <p class="sidebar__copyright">
      &copy; {{ _currentYear }} {{ _displayCompanyName() }}
    </p>
  </div>
</aside>
